import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuthFetch } from "../hooks/useAuthFetch";
import "../stili/StatisticheReti.css";

const API_URL = process.env.REACT_APP_API_URL;

export default function MarcatoriAssistStaff() {
  const navigate = useNavigate();
  const authFetch = useAuthFetch();

  const [stagioni, setStagioni] = useState([]);
  const [idStagione, setIdStagione] = useState("");
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchStagioni = useCallback(async () => {
    try {
      const res = await authFetch(`${API_URL}/api/admin/lookup/stagioni`);
      if (!res.ok) {
        throw new Error("Errore nel caricamento stagioni");
      }

      const data = await res.json().catch(() => []);
      setStagioni(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      toast.error("Errore nel caricamento stagioni");
    }
  }, [authFetch]);

  useEffect(() => {
    fetchStagioni();
  }, [fetchStagioni]);

  async function handleCaricaReport() {
    if (!idStagione) {
      toast.warning("Seleziona una stagione");
      return;
    }

    try {
      setLoading(true);

      const res = await authFetch(
        `${API_URL}/api/staff/statistiche/marcatori-assist?idStagione=${idStagione}`
      );

      if (!res.ok) {
        throw new Error("Errore nel caricamento del report");
      }

      const data = await res.json();
      setReport(data);
      toast.success("Report caricato con successo");
    } catch (err) {
      console.error(err);
      setReport(null);
      toast.error(err.message || "Errore durante il caricamento del report");
    } finally {
      setLoading(false);
    }
  }

  function renderClassificaRows(lista, tipo) {
    if (!Array.isArray(lista) || lista.length === 0) {
      return (
        <tr>
          <td colSpan="4" className="marcatori-assist-empty">
            Nessun dato disponibile
          </td>
        </tr>
      );
    }

    return lista.map((item, index) => (
      <tr key={`${tipo}-${item.idGiocatore}-${index}`}>
        <td>{index + 1}</td>
        <td>
          {item.cognome} {item.nome}
        </td>
        <td>{item.categoria}</td>
        <td>{item.totale}</td>
      </tr>
    ));
  }

  function renderFasceRows(fasce) {
    if (!Array.isArray(fasce) || fasce.length === 0) {
      return (
        <tr>
          <td colSpan="3" className="marcatori-assist-empty">
            Nessun dato disponibile
          </td>
        </tr>
      );
    }

    return fasce.map((fascia) => (
      <tr key={fascia.fascia}>
        <td>{fascia.fascia}</td>
        <td>{fascia.goalFatti}</td>
        <td>{fascia.goalSubiti}</td>
      </tr>
    ));
  }

  return (
    <div className="sfondo-immagine">
      <div className="marcatori-assist-page">
        <div className="marcatori-assist-container">
          <h2 className="marcatori-assist-title">Marcatori / Assistman</h2>

          <div className="marcatori-assist-filtri-card">
            <div className="marcatori-assist-filtri-row">
              <div className="marcatori-assist-field">
                <label>Stagione</label>
                <select
                  value={idStagione}
                  onChange={(e) => setIdStagione(e.target.value)}
                >
                  <option value="">Seleziona stagione</option>
                  {stagioni.map((stagione) => (
                    <option key={stagione.id} value={stagione.id}>
                      {stagione.nome}
                    </option>
                  ))}
                </select>
              </div>

              <div className="marcatori-assist-actions">
                <button
                  type="button"
                  className="btn-marcatori-assist primary"
                  onClick={handleCaricaReport}
                  disabled={loading}
                >
                  {loading ? "Caricamento..." : "Carica report"}
                </button>

                <button
                  type="button"
                  className="btn-marcatori-assist secondary"
                  onClick={() => navigate("/gestionale1")}
                >
                  Torna al gestionale
                </button>
              </div>
            </div>
          </div>

          {report && (
            <>
              <div className="marcatori-assist-grid">
                <div className="marcatori-assist-card">
                  <h3 className="marcatori-assist-card-title">
                    Classifica Marcatori
                  </h3>

                  <div className="marcatori-assist-table-wrap">
                    <table className="marcatori-assist-table">
                      <thead>
                        <tr>
                          <th>Pos.</th>
                          <th>Giocatore</th>
                          <th>Categoria</th>
                          <th>Gol</th>
                        </tr>
                      </thead>
                      <tbody>
                        {renderClassificaRows(report.marcatori, "marcatore")}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="marcatori-assist-card">
                  <h3 className="marcatori-assist-card-title">
                    Classifica Assistman
                  </h3>

                  <div className="marcatori-assist-table-wrap">
                    <table className="marcatori-assist-table">
                      <thead>
                        <tr>
                          <th>Pos.</th>
                          <th>Giocatore</th>
                          <th>Categoria</th>
                          <th>Assist</th>
                        </tr>
                      </thead>
                      <tbody>
                        {renderClassificaRows(report.assistman, "assist")}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="marcatori-assist-card marcatori-assist-card-wide">
                <h3 className="marcatori-assist-card-title">Statistiche Goal</h3>

                <div className="marcatori-assist-summary-grid">
                  <div className="marcatori-summary-box">
                    <span>Goal fatti</span>
                    <strong>{report.statisticheGoal?.goalFattiTotali ?? 0}</strong>
                  </div>

                  <div className="marcatori-summary-box">
                    <span>Goal subiti</span>
                    <strong>{report.statisticheGoal?.goalSubitiTotali ?? 0}</strong>
                  </div>

                  <div className="marcatori-summary-box">
                    <span>Differenza reti</span>
                    <strong>{report.statisticheGoal?.differenzaReti ?? 0}</strong>
                  </div>

                  <div className="marcatori-summary-box">
                    <span>Numero gare</span>
                    <strong>{report.statisticheGoal?.numeroGare ?? 0}</strong>
                  </div>
                </div>

                <div className="marcatori-assist-table-wrap">
                  <table className="marcatori-assist-table">
                    <thead>
                      <tr>
                        <th>Fascia</th>
                        <th>Goal fatti</th>
                        <th>Goal subiti</th>
                      </tr>
                    </thead>
                    <tbody>
                      {renderFasceRows(report.statisticheGoal?.fasce)}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}